/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconKnife: {
  name: 'knife';
  data: string;
} = {
  name: 'knife',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m279.713 160.123-.735.664C242.571 98.118 196.252 43.531 122.866 9.836 97.139-1.977 77.615 17.586 67.3 40.563c-40.518 90.26 101.621-1.849 175.729 152.694l-.294.266c-5.486 39.158-59.154 78.867-107.544 80.405 92.94 221.598 307.049 381.525 456.927 285.265-197.003-67.409-231.348-252.505-312.405-399.07z"/></svg>`,
};
